import { textAllCleaner } from '../../text-cleaner';
import { filterBrokerAlgos } from './broker';
import { filterSearchAlgos } from './search';
import { filterViewsAlgos } from './views';

export const filterAlgos = (data, filter = {}, brokersDataAll = []) => {
  const isViewsFilter =
    filter?.views && Object.keys(filter?.views).length ? true : false;
  const isSearchFilter =
    filter.search && textAllCleaner(filter?.search) !== '' ? true : false;
  const isBrokersFilter =
    filter.brokers && filter.brokers.length ? true : false;

  let newData = data;

  if (isViewsFilter) {
    newData = filterViewsAlgos(newData, filter.views, brokersDataAll);
  }

  if (isSearchFilter) {
    newData = filterSearchAlgos(newData, filter.search);
  }

  if (isBrokersFilter) {
    newData = filterBrokerAlgos(newData, filter.brokers, brokersDataAll);
  }

  return newData;
};

export const filterAlgosByBroker = (data, brokerId) => {
  const newData = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    if (element?.broker && brokerId === element?.broker) {
      newData.push(element);
    }
  }

  return newData;
};
